import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { selectFeatureFlags } from 'yoda-site-components/lib/selectors/ContextSelector';
import IRISContent from 'yoda-checkout-components/lib/components/IRISContent/IRISContent';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { CURBSIDE_CART_CONTENT } from 'yoda-checkout-components/lib/common/Constants';
import { isEmpty } from 'lodash';
import GiftCardBannerConnect from '../GiftCardBanner/GiftCardBanner';
import GiftCardBannerMsgBox from '../GiftCardBanner/GiftCardBannerMessage';
import PLCCDynamicBannerConnect from '../PLCCDynamicBanner/PLCCDynamicBanner';

function CartBanners({ togglePLCCDetailSlider }) {
    const { prioritizeCurbSideBanner = true } = useSelector(selectFeatureFlags);
    const showCurbsideBanner = useSelector((state) => state.orderInfo?.showCurbsideBanner);
    const showGiftCardBanner = useSelector((state) => state.giftCardBannerData?.showGiftCardBanner);
    const showGCMessageBox = useSelector((state) => state.giftCardBannerData?.showGCMsgBanner);
    const displayPlccBanner = useSelector((state) => state.plccDynamicBanner?.displayPlccBanner);
    const orderItems = useSelector((state) => state.orderItems);

    const renderCurbSideBanner = () => {
        return (
            showCurbsideBanner && (
                <div className={dt(['smMd:pb-2'])}>
                    <IRISContent componentName={CURBSIDE_CART_CONTENT} />
                </div>
            )
        );
    };

    const renderGiftCardBanner = () => {
        if (!showGCMessageBox && !showGiftCardBanner) {
            return null;
        }
        return (
            <>
                {showGCMessageBox && (
                    <div className={dt(['sm:hidden', 'lg:block'])}>
                        <GiftCardBannerMsgBox />
                    </div>
                )}
                {showGiftCardBanner && <GiftCardBannerConnect />}
            </>
        );
    };

    const renderDynamicPLCC = () => {
        if (isEmpty(orderItems)) {
            return null;
        }
        return displayPlccBanner ? (
            <PLCCDynamicBannerConnect
                initialRender
                togglePLCCDetailSlider={togglePLCCDetailSlider}
            />
        ) : null;
    };

    // Renders curbside over gift card and PLCC only if eligible
    if (prioritizeCurbSideBanner) {
        return (
            renderCurbSideBanner() || (
                <>
                    {renderGiftCardBanner()}
                    {renderDynamicPLCC(true)}
                </>
            )
        );
    }

    const dynamiCPLCC = renderDynamicPLCC(true);
    const giftCardBanner = renderGiftCardBanner();

    // else renders PLCC and gift card over curbside if eligible
    return dynamiCPLCC || giftCardBanner ? (
        <>
            {giftCardBanner}
            {dynamiCPLCC}
        </>
    ) : (
        renderCurbSideBanner()
    );
}

CartBanners.propTypes = {
    togglePLCCDetailSlider: PropTypes.func.isRequired,
};

export default CartBanners;
